export const devInitialState = {
  view: "signup",
  // 	signupListID: 84,
  signupListID: 8171,
  editMode: false,
};
